import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { useNavigate } from 'react-router';


import { Panel, PanelHeader } from '../../header/panel/panel';
import TableView from '../Table/Table';


import { fetchAllRegisters, filteredData, setRegisterEdit, setModifiedRegister, setRegisterID } from '../../../redux/actions/RegisterActions';
import { tableHeadings } from '../../../utils/constants';



const RegisterList = (props) => {

    const navigate = useNavigate()

    const [searchValue, setSearchValue] = useState('');

    useEffect(() => {
        props.fetchAllRegisters()
        props.setModifiedRegister(false)
        props.filteredData()

        return () => {
            props.setModifiedRegister(false)
        }
    }, [])

    const handleClick = (value) => {
        props.setRegisterID(value.data.registerID)
        console.log(value.data.registerID)
        navigate('/register/view')
    }


    const handleSearch = (event) => {
        setSearchValue(event.target.value)
        let filteredClients = event.target.value && event.target.value.length ? props.REGISTERREDUCER.posClientsData.filter(client => {
            if (client.registerID.toLowerCase().includes(event.target.value.toLowerCase())) {
                return client
            }
            return null
        }) : []

        props.filteredData(filteredClients)

    }

    return (


        <Panel>

            <PanelHeader>

                <div className="row mb-0">

                    <div className="col-xl-9">
                        <h4>Registers</h4>
                    </div>
                    <div className="col-xl-2">
                        <input type="text" className="form-control" placeholder="Search..." onChange={handleSearch} />

                    </div>
                    <div className="col-xl-1">
                        {/* {props.LOGINREDUCER.USER.role == 1 ? <button className="btn btn-sm btn-secondary d-block w-40 btn-lg h-35px fs-09px" onClick={handleAddISO}>Add ISO</button>
                        : null} */}
                    </div>

                </div>


            </PanelHeader>

            <TableView height={596} count={13} headings={tableHeadings.registers} data={(props.REGISTERREDUCER.filteredData && props.REGISTERREDUCER.filteredData.length) || searchValue ? props.REGISTERREDUCER.filteredData : props.REGISTERREDUCER.registersData} handleClick={handleClick} />

        </Panel>




    )
}

function mapStateToProps(state) {
    return state
}

const mapDispatchToProps = {
    fetchAllRegisters,
    filteredData,
    setRegisterEdit,
    setModifiedRegister,
    setRegisterID
}


export default connect(mapStateToProps, mapDispatchToProps)(RegisterList);